<template>
  <div v-if="!isMantenance" id="direct-delivery" class="panel-body">
    <p class="text-size-20">Amazon倉庫にある商品をACROSS倉庫へ納品する依頼を作成することができます</p>
    <div class="mr-t-20" style="min-width: 1500px;">
      <div class="flexbox gap-15">
        <svg width="50" height="50">
          <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">1</text>
        </svg>
        <span class="font-bold text-size-16 text-primary">基本情報入力</span>
      </div>
      <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
        <div class="box-delivery-name m-b-md">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="delivery-name"><strong>納品名</strong></div>
            </div>
            <div class="col-md-10 col-lg-7">
              <input type="text" :class="['form-control', deliveryName ? '' : 'bg-no-input']" v-model.trim="deliveryName">
              <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
              <div v-if="validateErrors.deliveryName.length" class="text-red"><b>{{ validateErrors.deliveryName[0]}}</b></div>
            </div>
          </div>
        </div>
        <div class="box-origin-info-default m-b-sm">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="m-b-sm"><strong>発送元情報</strong></div>
            </div>
            <div class="col-md-9 col-lg-10">
              Amazon倉庫
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mr-t-20" style="min-width: 1500px;">
      <div class="flexbox gap-15">
        <svg width="50" height="50">
          <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">2</text>
        </svg>
        <span class="font-bold text-size-16 text-primary">商品情報入力</span>
      </div>
      <div id="product-input" class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
        <fixed-header v-show="isShowFixedHeader" :textBtnRegister="'納品依頼'" @handleClickAdd="openModalDeliveryProductAdd()" @handleClickRegister="submitValidate()"/>
        <p class="">納品する商品を選択し、商品情報を入力してください。</p>
        <button type="button" class="btn btn-primary check-maintenance" @click.prevent="openModalDeliveryProductAdd()">商品選択</button>
        <button type="button" class="btn btn-warning check-maintenance" @click.prevent="openModalUpload()">CSVアップロード</button>
        <div v-if="selectedProducts.length" class="table-selected-products">
          <table>
            <thead>
              <tr>
                <th class="text-center w-150">納品する商品</th>
                <th style="min-width: 450px;"></th>
                <th class="w-250">商品ラベル</th>
                <th class="w-180">有効期限</th>
                <th class="w-180">
                  <div class="flexbox justify-right">
                    <img src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png" class="w-30 mr-r-5" />
                    <span>FBA長期在庫数</span>
                  </div>
                </th>
                <th class="text-right w-140">Amazon在庫数</th>
                <th class="text-right w-140">納品予定数</th>
                <th class="text-center">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(selectedProduct, index) in selectedProducts" :key="index">
                <td class="text-center">
                  <div class="box-selected-product-image w-40">
                    <img :src="selectedProduct.image" alt="" class="selected-product-image img-responsive">
                  </div>
                  <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(selectedProduct.status_str)}`">{{ selectedProduct.status_str }}</div>
                </td>
                <td>
                  <div class="m-b-xs">{{ selectedProduct.itemName }}</div>
                  <div><b>ASIN：</b>{{ selectedProduct.asin }} / <b>SKU：</b>{{ selectedProduct.sku }}</div>
                </td>
                <td class="fnsku-kbn-td td-vertical-top w-250">
                  <fnsku-kbn-item
                    class="mr-t-30"
                    :key="`fnskuKbn-${selectedProduct.sku}`"
                    :product="selectedProduct"
                    @update="updateStorageProducts()"
                  />
                  <div v-if="validateErrors.fnsku[selectedProduct.sku] && !selectedProduct.fnsku" class="text-red"><b>{{ validateErrors.fnsku[selectedProduct.sku]}}</b></div>
                </td>
                <td colspan="4">
                  <div style="display: flex; flex-direction: column;">
                    <div class="box-colspan">
                      <div class="box-due-date-manage w-180">
                        <due-date-management-item
                          :key="`due-date-manage-${selectedProduct.sku}`"
                          :product="selectedProduct"
                          @updateDueDateManageFlg="updateStorageProducts()"
                          @updateExpirationDate="updateStorageProducts()"
                        />
                      </div>
                      <div class="text-right w-180 pd-r-20">
                        <div class="h-30"></div>
                        <span v-if="isNaN(selectedProduct.agentReturnQuantity)" class="text-gray">{{ selectedProduct.agentReturnQuantity }}</span>
                        <span v-else class="">{{ formatNumber(selectedProduct.agentReturnQuantity) }} 個</span>
                      </div>
                      <div class="text-right w-130 pd-r-10">
                        <div class="h-30"></div>
                        <span class="">{{ formatNumber(selectedProduct.amazonQuantity) }} 個</span>
                      </div>
                      <div class="w-130 p-l-24">
                        <div class="h-30"></div>
                        <input type="text" class="form-control expected-delivery-number text-right pull-right" :class="parseInt(selectedProduct.quantity) && parseInt(selectedProduct.quantity) <= parseInt(selectedProduct.amazonQuantity) ? '' : 'bg-no-input'" v-model="selectedProduct.quantity" @input="selectedProduct.quantity = handleInputQuantity(selectedProduct.quantity)" @blur="updateStorageProducts()">
                      </div>
                    </div>
                    <div v-show="validateErrors.dueDateManagement[selectedProduct.sku] || validateErrors.quantity[selectedProduct.sku]" class="flexbox justify-between">
                      <div class="text-red"><b>{{ validateErrors.dueDateManagement[selectedProduct.sku]}}</b></div>
                      <div class="text-red text-right"><b>{{ validateErrors.quantity[selectedProduct.sku]}}</b></div>
                    </div>
                    <div :class="[getAvailabilityDate(selectedProduct) ? '' : 'availability-date-visibility']" class="m-t-xs availability-date">
                      出荷可能期限日：{{ getAvailabilityDate(selectedProduct) }}までの注文に対して出荷することができます。
                    </div>
                  </div>
                </td>
                <td class="td-vertical-top text-center">
                  <div class="h-30"></div>
                  <button type="button" class="btn btn-delete-selected-product check-maintenance" @click.prevent="deleteSelectedProduct(selectedProduct)">削除</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center m-b-md m-t-md">
            <button type="button" class="btn btn-primary custom-btn-delivery check-maintenance" @click.prevent="submitValidate">
              納品依頼
              <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div v-else class="empty-products text-center">
          <h3 class="m-b-xl text-center"><strong>商品選択より、納品する商品を選択してください。</strong></h3>
        </div>
      </div>
    </div>
    <delivery-product-add
      v-if="openDeliveryProductAddModal"
      ref="deliveryProductAddModal"
      :deliverySelectedProducts="storageSelectedProducts"
      :isAmazonReturn="true"
      :apiUrl="apiUrl"
      @close="closeModalDeliveryProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
    <modal-alert-get-latest-product
      v-if="showGetLatestProductModal"
      :message="getLatestProductNotiMessage"
      :customBodyClass="`text-center`"
      @close="closeGetLatestProductModal"
      @confirm="confirmGetLatestProductModal"
    />
    <modal-alert
      v-if="showGetLatestProductCompletedModal"
      :message="getLatestProductCompletedMessage"
      :customBodyClass="`text-center`"
      @close="closeGetLatestProductCompletedModal"
    />
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
    <modal-confirm
      v-if="openConfirmModal"
      :message="confirmMessage"
      @confirm="handleRegister"
      @close="closeModalConfirmAdd"
    />
    <modal-alert
      v-if="openAddedModal"
      :message="addedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlertProductsAdded"
    />
    <upload-csv-modal
      v-if="isShowUploadModal"
      :header="uploadCsvHeader"
      :uploadUrl="'Warehouse/across/delivery/amazon/product-available/upload'"
      :needProductId="true"
      @handleDownloadTemplate="handleDownloadTemplate"
      @handleUploadSuccess="handleUploadSuccess"
      @close="closeUploadModal"
    />
    <modal-alert
      v-if="openUploadedModal"
      :message="uploadedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeUploadedModal"
    />
  </div>
  <maintenance-modal v-else :html="userInfo.acrossDeliveryStopExp" :hasBypassMaintenance="true"  @close="closeMaintenanceModal" @bypassMaintenance="bypassMaintenance" />
</template>

<script>
import { mapGetters } from 'vuex'
import Util from '@/common/utility'
import moment from 'moment'
import FnskuKbnItem from '@/view/warehouseAcross/components/FnskuKbnItem'
import DueDateManagementItem from '@/view/deliveryRequests/components/DueDateManagementItem'
import ShippingPackingItem from '@/view/deliveryRequests/components/ShippingPackingItem'
import GoodsLabelAttachKbnItem from '@/view/deliveryRequests/components/GoodsLabelAttachKbnItem'
import ProductService from '@/services/productservice'
import SettingService from '@/services/settingservice'
import SalemonAgentService from '@/services/salemonagentservice'
import ModalAlert from '@/components/ModalAlert'
import ModalAlertGetLatestProduct from '@/view/warehouseAcross/components/ModalAlert'
import ModalConfirm from '@/components/ModalConfirm'
import DeliveryProductAdd from '@/view/warehouseAcross/components/AmazonDeliveryProductAdd'
import FixedHeader from './components/FixedHeader'
import MaintenanceModal from '@/view/warehouses/MaintenanceModal'
import UploadCsvModal from '@/components/UploadCsvModal'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAlert,
    ModalAlertGetLatestProduct,
    ModalConfirm,
    FnskuKbnItem,
    DueDateManagementItem,
    ShippingPackingItem,
    GoodsLabelAttachKbnItem,
    DeliveryProductAdd,
    FixedHeader,
    MaintenanceModal,
    UploadCsvModal
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      apiUrl: '/Warehouse/across/delivery/amazon/product-available',
      loader: null,
      isMantenance: true,
      showGetLatestProductModal: false,
      showGetLatestProductCompletedModal: false,
      openConfirmModal: false,
      openAddedModal: false,
      openDeliveryProductAddModal: false,
      openAlertValidateFailsModal: false,
      isShowFixedHeader: false,
      deliveryNo: null,
      deliveryName: null,
      validateErrors: {
        deliveryName: [],
        quantity: {},
        fnsku: {},
        dueDateManagement: {}
      },
      storageSelectedProducts: [],
      getLatestProductNotiMessage: '商品情報を最新化する必要があります。<br> はじめに最新の商品情報を取得します。',
      getLatestProductCompletedMessage: '商品が最新状態に更新されました。',
      alertValidateFailsMessage: '入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。',
      confirmMessage: '納品情報を登録します。よろしいですか？',
      isShowUploadModal: false,
      totalUpload: 0,
      invalidUpload: [],
      duplicateUpload: [],
      openUploadedModal: false
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    storageName () {
      return `${this.userInfo.sellerId}-AmazonDeliverySelectedProducts`
    },
    selectedProducts () {
      return this.storageSelectedProducts
    },
    addedMessage () {
      return `
        納品情報を受付けました。 <br>
        納品管理番号： ${this.deliveryNo} <br> <br>
        <p>
          Amazon倉庫からACROSS倉庫への返送納品は自動的に行われますが<br>
          納品プロセスにおいてエラーとなり、倉庫へ納品できない可能性があります。<br> <br>
          詳しくは、別途ご送付するメールをご参照いただくか、 <br>
          または納品状況照会画面よりご確認をお願いします。
        </p>
        <br>
        <p>
          <span class="text-danger">※受取金額をご確認ください</span> <br>
          セルモンに出品している商品の場合、「商品管理 > 商品一覧」 画面にて <br>
          ACROSS倉庫商品の受取金額を確認・変更いただくことが可能です。
        </p>
      `
    },
    uploadCsvHeader () {
      return `<div class="flexbox">
        <img src="${this.$store.getters.getWareHouseIcons.Amazon}" class="w-20">Amazon倉庫 → <img src="${this.$store.getters.getWareHouseIcons.salmonAcross}" class="w-20"> ACROSS倉庫へ納品する商品・数量をアップロードしてください
      </div>
      <span style="color: red; font-size: 14px;">「テンプレートをダウンロード」よりテンプレートをダウンロード・編集の上、ご登録ください。</span>
      `
    },
    uploadedMessage () {
      const successUpload = Math.max(0, this.totalUpload - this.invalidUpload.length - this.duplicateUpload.length)
      let html = `<p><b>${successUpload}件/${this.totalUpload}件 商品の追加が成功しました</b></p>`

      if (this.invalidUpload.length > 0) {
        html += `<div class="text-danger"><b>エラー${this.invalidUpload.length}件 商品が存在しません</b></div>`
        this.invalidUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      if (this.duplicateUpload.length > 0) {
        html += '<br>'
        html += `<div class="text-danger"><b>エラー${this.duplicateUpload.length}件 商品が重複しています</b></div>`
        this.duplicateUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      return html
    }
  },
  methods: {
    bypassMaintenance () {
      $('#maintenance-modal').modal('hide')
      this.isMantenance = false
    },
    closeMaintenanceModal () {
      $('#maintenance-modal').modal('hide')
      this.$router.push('/warehouse-across/delivery/delivery-status-inquiry')
    },
    async init () {
      if (this.$route.query.mode && this.$route.query.mode === 'agent') {
        this.clearStorage()
        this.getAgentProducts()
        return
      }

      const query = this.$route.query
      if (query && query.deliveryNo) {
        this.getAmazonDeliveryDetail(query.deliveryNo)
      } else {
        this.getSelectedProducts()
      }
    },
    async getAgentProducts () {
      this.loader = this.$loading.show()
      await SalemonAgentService.getProductsToAmazonDelivery()
        .then((response) => {
          localStorage.setItem(this.storageName, JSON.stringify(response.data))
          this.storageSelectedProducts = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    closeGetLatestProductModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductModal = false
    },
    confirmGetLatestProductModal () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_update_inventory_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.closeGetLatestProductModal()
      this.getLatestProduct()
    },
    closeGetLatestProductCompletedModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductCompletedModal = false
    },
    closeModalDeliveryProductAdd () {
      $('#delivery-product-add-modal').modal('hide')
      this.openDeliveryProductAddModal = false
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    openModalConfirmAdd () {
      if (this.isValidateFails) return
      this.openConfirmModal = true
    },
    closeModalConfirmAdd () {
      $('#confirm-alert').modal('hide')
      this.openConfirmModal = false
    },
    openModalAdded () {
      this.openAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAddedModal = false
      this.deliveryName = null
      this.deliveryNo = null
      this.$router.push({
        name: 'Warehouse across',
        params: {
          tab: 'delivery',
          subTab: 'delivery-status-inquiry'
        }
      })
    },
    async getAmazonDeliveryDetail (deliveryNo) {
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: deliveryNo
      }
      await WarehouseAcrossService.getAmazonDeliveryDetail(params)
        .then((response) => {
          this.deliveryName = response.data.deliveryName
          localStorage.setItem(this.storageName, JSON.stringify(response.data.deliveryGoods))
          this.storageSelectedProducts = response.data.deliveryGoods
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    getSelectedProducts () {
      this.storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageName) || '[]')
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    deleteSelectedProduct (product) {
      this.storageSelectedProducts = this.storageSelectedProducts.filter(item => item.sku !== product.sku)
      localStorage.setItem(this.storageName, JSON.stringify(this.storageSelectedProducts))
    },
    handleSelectedProduct (product) {
      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageName) || '[]')
      let selectedProducts = [...storageSelectedProducts, product]
      localStorage.setItem(this.storageName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    handleSelectedProducts (products) {
      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageName) || '[]')
      let selectedProducts = [...storageSelectedProducts, ...products]
      localStorage.setItem(this.storageName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    updateStorageProducts () {
      let selectedProducts = this.storageSelectedProducts
      localStorage.removeItem(this.storageName)
      this.storageSelectedProducts = []
      this.handleSelectedProducts(selectedProducts)
    },
    getAvailabilityDate (product) {
      let availabilityDate = ''
      let expirationDate = product.expirationDate
      if (!expirationDate) {
        return availabilityDate
      }
      let minusDate = product.settingShippingNgPeriodValue

      if (product.hasYamatoOffer && product.yamatoShippingNgPeriod) {
        minusDate = product.yamatoShippingNgPeriod
      }

      let newDate = new Date(expirationDate)
      newDate.setDate(newDate.getDate() - minusDate)
      availabilityDate = moment(newDate).format('YYYY/MM/DD')

      return availabilityDate
    },
    checkLatestProductDate () {
      if (this.userInfo.getLatestProductsDate === null) {
        return true
      }
      const minusUpdateLatest = 120
      let getLatestProductsDate = new Date(this.userInfo.getLatestProductsDate)
      getLatestProductsDate.setTime(getLatestProductsDate.getTime() + minusUpdateLatest * 60 * 1000)
      let now = new Date()
      return now.getTime() >= getLatestProductsDate.getTime()
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    openModalDeliveryProductAdd () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_select_product_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      if (this.checkLatestProductDate()) {
        this.showGetLatestProductModal = true
      } else {
        this.openDeliveryProductAddModal = true
      }
    },
    async getLatestProduct () {
      this.loader = this.$loading.show()
      await ProductService.getLatestProducts()
        .then((response) => {
          this.clearStorage()
          this.getSellerInfo()
          this.loader && this.loader.hide()
          this.showGetLatestProductCompletedModal = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
    },
    clearStorage () {
      localStorage.removeItem(this.storageName)
      this.storageSelectedProducts = []
    },
    async submitValidate () {
      this.loader = this.$loading.show()
      let params = {
        deliveryGoods: this.storageSelectedProducts
      }
      await WarehouseAcrossService.updateAmazonInventory(params)
        .then((response) => {
          this.storageSelectedProducts = response.data
          this.validateInput()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    validateInput () {
      let required = '※必ず入力してください'
      let number = '※半角数値で入力してください'
      let validateMin = '※1以上の数値を入力してください'
      let validateMax = '※Amazon在庫数以内で入力してください'
      this.isValidateFails = false
      if (!this.deliveryName || !this.deliveryName.trim()) {
        this.validateErrors.deliveryName.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.deliveryName = []
      }
      this.storageSelectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let sku = product.sku
        let isQuantityNaN = (product.quantity !== '' && product.quantity !== null) ? isNaN(product.quantity) : false
        this.validateErrors.quantity[sku] = ''
        this.validateErrors.dueDateManagement[sku] = ''
        if (isQuantityNaN) {
          this.validateErrors.quantity[sku] = number
          this.isValidateFails = true
        } else if (!isQuantityNaN && !quantity) {
          this.validateErrors.quantity[sku] = required
          this.isValidateFails = true
        } else if (!isQuantityNaN && quantity === 0) {
          this.validateErrors.quantity[sku] = validateMin
          this.isValidateFails = true
        } else if (!isQuantityNaN && quantity > product.amazonQuantity) {
          this.validateErrors.quantity[sku] = validateMax
          this.isValidateFails = true
        } else {
          delete this.validateErrors.quantity[sku]
        }

        if (!product.expirationDate && product.dueDateManageFlg) {
          this.validateErrors.dueDateManagement[sku] = required
          this.isValidateFails = true
        } else {
          delete this.validateErrors.dueDateManagement[sku]
        }

        if (!product.fnsku) {
          this.validateErrors.fnsku[sku] = required
          this.isValidateFails = true
        } else {
          delete this.validateErrors.fnsku[sku]
        }
      })
      this.updateStorageProducts()

      if (this.isValidateFails) {
        this.openModalAlertValidateFails()
      } else {
        this.openModalConfirmAdd()
      }
    },
    handleRegister () {
      if (this.isValidateFails) return

      this.loader = this.$loading.show()

      let params = {
        deliveryGoods: this.storageSelectedProducts,
        deliveryName: this.deliveryName
      }
      WarehouseAcrossService.registerAmazonDelivery(params)
        .then((response) => {
          this.closeModalConfirmAdd()
          this.deliveryNo = response.data.deliveryNo
          this.loader && this.loader.hide()
          this.openModalAdded()
          this.clearStorage()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          let logParams = {
            name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_request_delivery_btn,
            properties: {
              deliveryNo: this.deliveryNo
            }
          }
          EventService.postTrackLog(logParams)

          this.loader && this.loader.hide()
        })
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      if (fixedHeader) {
        const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
        this.isShowFixedHeader = window.scrollY >= initialOffset
      }
    },
    handleInputQuantity (value) {
      return value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    },
    openModalUpload () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_upload_by_csv,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.checkLatestProductDate()) {
        this.showGetLatestProductModal = true
      } else {
        this.isShowUploadModal = true
      }
    },
    closeUploadModal () {
      this.isShowUploadModal = false
      $('#upload-csv-modal').modal('hide')
    },
    closeUploadedModal () {
      this.openUploadedModal = false
      $('#myModal').modal('hide')
    },
    handleDownloadTemplate () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.amazon_delivery.click_download_template,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      WarehouseAcrossService.downloadProductsCsvTemplate({}, '納品テンプレート.csv')
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    },
    handleUploadSuccess (response) {
      this.clearStorage()
      const data = response.records.data
      this.totalUpload = data.total
      this.invalidUpload = data.invalid
      this.duplicateUpload = data.duplicate
      this.handleSelectedProducts(data.products)
      this.closeUploadModal()
      this.openUploadedModal = true
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.delivery_tab.amazon_delivery.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    window.addEventListener('scroll', this.handleScroll)
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.step-rectangle {
  border: 2px solid #008cc6;
  border-radius: 8px;
  padding: 5px;
  width: 350px;
  height: 70px;
}
.text-primary {
  color: #008cc6;
}
.table-selected-products {
  margin-top: 10px;
  /* overflow: auto; */
  padding: 0
}
.table-selected-products table {
  border: 1px solid #ccc
}
.table-selected-products th, .table-selected-products td{
  padding: 5px 10px;
  min-width: 120px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.table-selected-products th {
  color: #595959;
  background-color: #deebf7;
}
.td-vertical-top {
  vertical-align: top;
}
#direct-delivery {
  overflow: auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.custom-btn-delivery {
  font-size: 20px;
  padding: 10px 50px;
  border-radius: 8px;
  background-color: #0070c0;
}
</style>
<style>
#direct-delivery .bg-no-input {
  background-color: #fdefef !important;
}
#direct-delivery .row {
  margin-left: -15px;
  margin-right: -15px;
}
#direct-delivery .mx-datepicker {
  width: 150px;
}
.table-selected-products .box-due-date-manage {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/AmazonDelivery.vue